<template>

  <div class="single-element">

    <section class="content-rows">
     <div class="row intro">
      <section class="idt">
        <label>ID</label>
      </section>

      <section class="langt">
        <label>LINGUA</label>
      </section>

      <section class="namet">
        <label>NOME</label>
      </section>

      <section class="valuet">
        <label>VALORE</label>
      </section>

    </div>

      <div  v-for="(t, index) in transModel" :key="index" class="row" :data-idt="t.id" :data-lang="t.lang" :data-is-editable="isEditable(t)">
        <section class="idt">
          <span class="bold">{{t.code_search}}</span>
        </section>

        <section class="langt">
          <span class="w-lang">
            <span class="w-icon">
               <img class="icon" :src="icon[t.lang]" alt="Icona lingua">
            </span>
            <span class="bold uc">{{t.lang}}</span>
          </span>
        </section>

        <section class="namet">
          <span class="bold">{{t.name}}</span>
        </section>

        <section class="valuet" :data-lang="t.lang">
          <span class="val current" v-show="!translateString(t, 'isset')" @click="translateString(t, 'add')">{{t.value}}</span>
          <span v-if="translateString(t, 'isset')">
            <textarea v-model="new_trans[keySlug(t)]" name="trans_model" cols="30" rows="5"></textarea><br>
            <div class="actions">
              <button @click="translateString(t, 'undo')" class="belt-btn-small red uptrans">annulla</button>
              <button @click="updateTranslation(t)" class="belt-btn-small blue uptrans">aggiorna</button>
              <span v-if="t.id > 0" @click="deleteString(t, 'add', index)" class="action-component red delete">elimina</span>
            </div>

            <div class="delete-confirm" v-if="deleteString(t, 'isset',  index)">
              <h3>Eliminare questa stringa?</h3>
              <div class="actions-confirm">
                <button class="denied" @click="deleteString(t, 'undo',  index)">No, mantieni</button>
                <button class="confirm" @click="deleteTranslation(t, index)">Si, elimina</button>
              </div>
            </div>

          </span>

        </section>
      </div>

    </section>

  </div>

</template>

<script>

export default{

  props: {
    transModel: {type: Array},
  },

  data: function(){

    return {
      icon: {
        it: this.url('/media/icons/svg/lang/it.svg'),
        en: this.url('/media/icons/svg/lang/en.svg'),
        es: this.url('/media/icons/svg/lang/es.svg'),
        fr: this.url('/media/icons/svg/lang/fr.svg'),
        pt: this.url('/media/icons/svg/lang/pt.svg'),
        de: this.url('/media/icons/svg/lang/de.svg'), // tedesco
        zh: this.url('/media/icons/svg/lang/zh.svg'), // svizzerro
        pl: this.url('/media/icons/svg/lang/pl.svg'),
        ru: this.url('/media/icons/svg/lang/ru.svg'),
      },
      new_trans: {},
      delete_trans: {},
    }

  },

  mounted: function() {

  },

  computed: {


  },

  methods: {
    isEditable: function (t) {
      return (
              t.lang != 'it' ||
              ['App\\Models\\Contenuto'].indexOf(t.model_type) > -1 ||
              'App\\Models\\Family' == t.model_type && t.name == 'des_estesa'
            ) ? 1 : 0;
    },

    keySlug: function(t) {
      return t.id + '_' + t.model_id + '_' + t.name + '_' + t.lang;
    },

    translateString: function(t, action) {
      if ( !this.isEditable(t) )
        return;
      switch (action) {
        case 'isset':
        return this.keySlug(t) in this.new_trans;
        break;
        case 'add':
        this.$set(this.new_trans, this.keySlug(t), t.value );
        break;

        case 'delete':
        this.$delete(this.new_trans, this.keySlug(t));
        break;

        case 'undo':
        this.$delete(this.new_trans, this.keySlug(t));
        break;
      }
    },

    deleteString: function(t, action, index) {
      if ( !this.isEditable(t) )
        return;
      switch (action) {
        case 'isset':
        return this.keySlug(t) in this.delete_trans;
        break;
        case 'add':
        this.$set(this.delete_trans, this.keySlug(t), t.value );
        break;

        case 'delete':
        this.$delete(this.delete_trans, this.keySlug(t));
        break;

        case 'undo':
        this.$delete(this.delete_trans, this.keySlug(t));
        break;
      }
    },

    deleteTranslation: function (t, index) {

      var vue = this;

      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/translations/delete',
        params: {
          json: JSON.stringify({
                  trans: t,
                }),
        }
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.deleteString(t, 'delete');
        vue.translateString(t, 'delete'); // eliminazione in new_trans
        // t.model_id = res.data.translation_default;
        t.value = res.data.translation_default.value;
        t.id = res.data.translation_default.id;
      })
      .catch(err => {

        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message,
          autoclose: false
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    updateTranslation: function(t) {

      var newTrans = this.new_trans[this.keySlug(t)].trim();

      if(newTrans == '') {
        this.$store.commit('add_message', {
          type: 'info',
          message: 'Non si salvano stringhe vuote'
        });
        this.translateString(t, 'delete');
        return;
      } else if (newTrans === t.value){
        this.translateString(t, 'delete');
        return;
      };

      var vue = this;

      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/translations/update',
        params: {
          json: JSON.stringify({
                  trans: t,
                  new_trans_value: newTrans,
                }),
        }
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.translateString(t, 'delete');
        t.value = res.data.translation.value;
        t.id = res.data.translation.id;
        t.created_at = res.data.translation.created_at;
        t.updated_at = res.data.translation.updated_at;
      })
      .catch(err => {

        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message,
          autoclose: false
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

  }

}
</script>

<style scoped>
.action-component.delete {
  margin-left: 2em;
}
div.single-element section.content-rows .row{
  width: 100%;
  display: flex;
  /* align-items: center; */
  /* justify-content: space-between; */
  font-size: 1em,;
  margin-bottom: 0.5em;
  padding: 0.6em 1em;
}
div.single-element section.content-rows .row[data-idt="0"]:not([data-lang="it"]) {
  background-color: var(--disabled);
}
.idt {
  width: 300px;
}
.langt, .namet {
  width: 120px;
}
.langt .w-lang {
  display: flex;
  align-items: center;
}
.langt .w-icon {
  margin-right: 4px;
}
.valuet span.val {
  cursor: pointer;
  padding: 2px;
}
.row[data-is-editable="0"] .valuet span.val{
  cursor: no-drop;
}
.row:not([data-is-editable="0"]) .valuet:hover span.val {
  box-shadow: 0px 0px 2px 1px var(--blue);
}
div.single-element section{

  height: auto;
}
div.single-element section label{
  display: block;
  width: 100%;
}
div.single-element section.datetime label {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
div.single-element img.icon{
  width: 20px;
}

div.single-element section.manage-rows{
  text-align: right;
}

div.single-element section span.date {
  font-size: 0.8em;
}
div.single-element section.status span.failed{
  color: var(--red);
}
div.single-element section.status span.successeful{
  color: var(--blue);
}

div.single-element section.status.single-sync span[data-status="in corso"] {
  color: var(--black);
}
div.single-element section.status.single-sync span[data-status="concluso"] {
  color: var(--blue);
}
div.single-element section.status.single-sync span[data-status="interrotto"] {
  color: var(--red);
}
textarea[name="trans_model"] {
  border: 1px solid var(--checkbox-gray);
  height: auto;
  overflow-y: auto;
  width: 100%;
}
.valuet span.current {
  display: block;
  height: auto;
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
  max-width: 500px;
  min-width: 140px;
  min-height: 1.4em;
}
button.blue,
button.confirm {
	color: white;
	background-color: var(--blue-message);
	border: 1px solid var(--blue-message);
}
button.blue:hover,
button.confirm:hover {
  background-color: white;
  color: var(--blue);
}
button.red,
button.denied{
	color: white;
	background-color: var(--red);
	border: 1px solid var(--red);
}
button.red:hover,
button.denied:hover {
  background-color: white;
  color: var(--red);
}
button.uptrans {
  width: 90px;
}
.valuet {
  position: relative;
}
.delete-confirm {
	position: absolute;
	top: 0;
	background: white;
	opacity: 0.9;
	width: 100%;
	height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
